import { Link, Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <header className="border-b border-border">
        <div className="mx-auto flex max-w-content-wide items-center justify-between px-5 py-5 md:px-10 lg:px-20">
          <Link to="/" className="font-display text-h3 font-semibold tracking-tight">
            HEXDI
          </Link>
        </div>
      </header>
      <main className="flex flex-1 items-center justify-center px-5 py-12 md:px-10 lg:px-20">
        <Outlet />
      </main>
    </div>
  );
}
